export class Time {
  public deltaSeconds = 0;
  public elapsedSeconds = 0;
  private previousMilliseconds = performance.now();

  public tick(nowMilliseconds = performance.now()): void {
    this.deltaSeconds = Math.min(
      0.05,
      Math.max(0, (nowMilliseconds - this.previousMilliseconds) / 1000),
    );
    this.elapsedSeconds += this.deltaSeconds;
    this.previousMilliseconds = nowMilliseconds;
  }

  public reset(nowMilliseconds = performance.now()): void {
    this.deltaSeconds = 0;
    this.elapsedSeconds = 0;
    this.previousMilliseconds = nowMilliseconds;
  }
}
